import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
// import {ScrollDispatchModule} from '@angular/cdk/scrolling';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CdkStepperModule} from '@angular/cdk/stepper';
import { MaterialFileInputModule } from 'ngx-material-file-input';



@NgModule({
   imports: [
      CommonModule,
      MatDialogModule,
      MatAutocompleteModule,
      MatSliderModule,
      MatPaginatorModule,
      MatDatepickerModule,
      MatStepperModule,
      MatNativeDateModule,
      MatTabsModule,
      MatListModule,
      MatSidenavModule,
      DragDropModule,
      MatCheckboxModule,
      MatToolbarModule,
      MatExpansionModule,
      MatMenuModule,
      MatProgressSpinnerModule,
      MatIconModule,
      MatProgressBarModule,
      MatButtonModule,
      MatBadgeModule,
      MatTooltipModule,
      MatDividerModule,
      MatCardModule,
      MatGridListModule,
      MatSlideToggleModule,
      MatButtonToggleModule,
      MatInputModule,
      MatRadioModule,
      MatSnackBarModule,
      ScrollingModule,
      // ScrollDispatchModule,
      MatSelectModule,
      CdkStepperModule,
      MaterialFileInputModule

   ],
   exports: [
       MatListModule,
       MatDialogModule,
       MatAutocompleteModule,
       MatSliderModule,
       MatDatepickerModule,
       MatPaginatorModule,
       MatStepperModule,
       MatNativeDateModule,
       DragDropModule,
       MatTabsModule,
       MatSidenavModule,
       MatProgressBarModule,
       MatToolbarModule,
       MatMenuModule,
       MatExpansionModule,
       MatProgressSpinnerModule,
       MatIconModule,
       MatButtonModule,
       MatTooltipModule,
       MatBadgeModule,
       MatDividerModule,
       MatCardModule,
       MatCheckboxModule,
       MatGridListModule,
       MatSlideToggleModule,
       MatButtonToggleModule,
       MatInputModule,
       MatRadioModule,
       MatSnackBarModule,
       ScrollingModule,
       // ScrollDispatchModule,
       MatSelectModule,
       CdkStepperModule,
       MaterialFileInputModule

   ],
   providers: [

   ]
})

export class AngularMaterialModule { }
